/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e,t,u as n}from"vendor/lit";import{a as r,i,t as a}from"vendor/decorate";var o=class extends t{constructor(...e){super(...e),this.layout=window.theme?.storageUtil.get(`products-layout`)||`grid`}static{this.styles=[n`
      .skeleton-wrapper {
        display: flex;
        flex-wrap: nowrap;
        gap: calc(2 * var(--space-unit));

        & > * {
          flex-basis: 50%;
        }
      }

      .skeleton,
      .skeleton-wrapper > * {
        background-color: var(--blend-bg-color);
        position: relative;
        overflow: hidden;
        min-height: 1em;
        border-radius: calc(var(--coll-card-border-radius) / 2);

        &::after {
          content: "";
          position: absolute;
          inset: 0;
          transform: translateX(-100%);
          animation: shimmer 2s infinite;
          background-image: linear-gradient(
            90deg,
            rgb(var(--label-color) / 0) 0,
            rgb(var(--label-color) / 0.1) 25%,
            rgb(var(--label-color) / 0.1) 75%,
            rgb(var(--label-color) / 0)
          );
        }
      }

      @keyframes shimmer {
        100% {
          transform: translateX(100%);
        }
      }

      :host {
        product-card {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          padding: calc(5 * var(--space-unit));
          width: 100%;
        }
      }

      :host([layout="list"]:first-of-type) {
        padding-top: 0;

        @media (width >= 1024px) {
          product-card {
            padding-top: 0;
          }
        }
      }

      :host([layout="list"]) {
        padding-top: calc(10 * var(--space-unit));
        padding-bottom: calc(10 * var(--space-unit));
        border-bottom: 1px solid rgb(var(--text-color) / 0.15);

        @media (width >= 769px) {
          product-card {
            flex-direction: row;
            padding-inline: 0;
          }

          .card__media {
            flex: 0 0 calc(33.3333% - calc(8 * var(--space-unit)));
            max-width: 245px;
            margin-block-end: 0;
            margin-inline-end: var(--gutter);
          }

          .card__info-container {
            display: flex;
            flex: 1 1 auto;
            flex-direction: row;
            align-items: flex-start;
            gap: calc(12 * var(--space-unit));
            justify-content: space-between;
          }

          .card__info {
            padding-top: 0;
          }

          .card__vendor {
            margin-top: 0;
          }

          .card__info-header {
            flex-grow: 1;
            width: 100%;
          }

          .card__info-fitment {
            flex-basis: 200px;
          }
        }
      }

      .card__info {
        display: flex;
        flex-direction: column;
        gap: calc(2 * var(--space-unit));
        padding-top: calc(2 * var(--space-unit));
      }

      .card__media {
        aspect-ratio: 4 / 3;
        background-color: var(--blend-bg-color);
        border-radius: var(--coll-card-border-radius);
        overflow: hidden;
        padding: calc(3 * var(--space-unit));
      }

      .card__vendor {
        font-size: 10px;
        margin: calc(2 * var(--space-unit)) 0 calc(3.5 * var(--space-unit));
        width: 80%;
      }

      .card__title {
        font-size: 18px;
        margin-bottom: 0;
      }

      .card__info-footer {
        margin-top: calc(2 * var(--space-unit));
        justify-content: space-between;

        .price {
          flex-basis: 30%;
        }
      }
    `]}render(){return e`
      <li>
        <product-card
          class="card card--product h-full card--product-contained relative flex"
        >
          <div class="card__media skeleton"></div>

          <div class="card__info-container">
            <div class="card__info-header">
              <div class="card__info">
                <div class="card__info-inner">
                  <div class="card__vendor skeleton-wrapper">
                    <span></span>
                    <span></span>
                  </div>

                  <div class="skeleton card__title"></div>
                </div>

                <div class="card__info-footer skeleton-wrapper">
                  <span class="price"></span>
                  <span></span>
                </div>
              </div>
            </div>

            <div class="card__info-fitment"></div>
          </div>
        </product-card>
      </li>
    `}};a([i({type:String,reflect:!0})],o.prototype,`layout`,void 0),o=a([r(`kanter-search-result-skeleton`)],o);export{o as SearchResultSkeleton};